/**
 * Font stacks. The @font-face rules live in `fonts.css`.
 *  - body:    default UI text (Inter Tight)
 *  - display: big headings and stat numbers (Unbounded)
 *  - jakarta: the course player's own typeface (Plus Jakarta Sans)
 */
export const fontFamilies = {
  body: '"Inter Tight", "Roboto", sans-serif',
  display: '"Unbounded", "Inter Tight", sans-serif',
  jakarta: '"Plus Jakarta Sans", "Inter Tight", sans-serif',
};
